import React, { useState } from "react";
import "./RHomepage.css";
import RNavbar from "../component/RNavbar";

import first from "../img/first.png";

import rfirst from "../img/first.avif";
import rsuccess from "../img/success.avif";
import success from "../img/success.png";
import rarrow from "../img/r-arrow.png";
import sqrarrow from "../img/sqr-arrow.png";
import RFooter from "../component/RFooter";

import support from "../img/howWeWork/customerSupport.png";
import sqsupport from "../img/howWeWork/sqcustomerSupport.png";
import paper from "../img/howWeWork/paperSupport.png";
import sqpaper from "../img/howWeWork/sqpaperSupport.png";

import syno from "../img/howWeWork/syno.png";
import sqsyno from "../img/howWeWork/sqsyno.png";
import researchi from "../img/howWeWork/research.png";
import sqresearchi from "../img/howWeWork/sqresearch.png";
import coding from "../img/howWeWork/coding.png";
import sqcoding from "../img/howWeWork/sqcoding.png";

import article from "../img/howWeWork/article.png";
import sqarticle from "../img/howWeWork/sqarticle.png";
import stats from "../img/howWeWork/stats.png";
import sqstats from "../img/howWeWork/sqstats.png";

import defaultUser from "../img/review/user.png";
import sqdefaultUser from "../img/review/squser.png";

import Calculator from "../component/Calculator";

import { LazyLoadImage } from "react-lazy-load-image-component";
import Connect from "../component/Connect";
import { useEffect } from "react";
function RHomepage() {
  const [ir, cir] = useState(0);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const reviews = [
    {
      name: "Nikita Wani",
      src: defaultUser,
      pos: "CEO @educlan",
      review:
        "Educlan.in was developed by team qodeit and they did brilliant work and we have very less time as, we were worried that, we will get quality work or not but the final work is perfect and we were very happy with their services.",
    },
    {
      name: "Vinay Mishra",
      src: defaultUser,
      pos: "@Client",
      review:
        "The best place for my IT solution with the best people around , Qodeit got the best team and customer support. Thanks alot!",
    },
    {
      name: "Lavanya Rao",
      src: defaultUser,
      pos: "@Client",
      review: "Best Tech service providers to scale up business 👍",
    },
    {
      name: "Kavita Aherwar",
      src: defaultUser,
      pos: "@Client",
      review: "Was a great experience working with them.",
    },
    {
      name: "Sanjay Singh Bhandari",
      src: defaultUser,
      pos: "@Local Guide",
      review: "Services are really nice",
    },
  ];

  return (
    <div>
      <div className="head-sec">
        <RNavbar main="main" />
        <Connect />

        <div className="main">
          <div className="main-text">
            <p>Qodeit</p>
            <h1>Let's Start</h1>
            <h1>Something Big</h1>
            <div className="together">
              <h1>Together</h1>
            </div>
            <p className="main-text-a">
              Our objective is to bridge the gap between the changing needs of
              research Students with our innovative, creative & experienced
              team. We believe in providing quality services and maintaining
              long-term relationships.
            </p>
          </div>
          <div className="main-img">
            <LazyLoadImage
              alt="qodeit"
              effect="blur"
              src={success}
              placeholderSrc={rsuccess}
              width="400px"
              height="400px"
            />
          </div>
          <div className="home-calc">
            <Calculator />
          </div>
        </div>

        <div className="main-stats">
          <div>
            <h2>25+</h2>
            <p>Research papers</p>
          </div>
          <div>
            <h2>8+ Years</h2>
            <p>Experience</p>
          </div>
          <div>
            <h2>100+</h2>
            <p>Satisfied customers</p>
          </div>
          <div>
            <button className="btn">Connect</button>
          </div>
        </div>
      </div>

      <div className="service-c">
        <div className="service-head-text">
          <p>We will help you! Trust us</p>
          <h1>Our Service</h1>
        </div>
        <div className="services">
          <div className="service">
            <LazyLoadImage
              alt="service icon"
              effect="blur"
              src={researchi}
              placeholderSrc={sqresearchi}
              width="60px"
              height="60px"
            />
            <h2>Research proposals</h2>
          </div>

          <div className="service">
            <LazyLoadImage
              alt="service icon"
              effect="blur"
              src={syno}
              placeholderSrc={sqsyno}
              width="60px"
              height="60px"
            />
            <h2>Synopsis writing</h2>
          </div>
          <div className="service">
            <LazyLoadImage
              alt="service icon"
              effect="blur"
              src={article}
              placeholderSrc={sqarticle}
              width="60px"
              height="60px"
            />
            <h2>Article writing</h2>
          </div>

          <div className="service">
            <LazyLoadImage
              alt="service icon"
              effect="blur"
              src={paper}
              placeholderSrc={sqpaper}
              width="60px"
              height="60px"
            />
            <h2>Thesis writing</h2>
          </div>

          <div className="service">
            <LazyLoadImage
              alt="service icon"
              effect="blur"
              src={stats}
              placeholderSrc={sqstats}
              width="60px"
              height="60px"
            />
            <h2>Statistics & data analysis</h2>
          </div>
          <div className="service">
            <LazyLoadImage
              alt="service icon"
              effect="blur"
              src={support}
              placeholderSrc={sqsupport}
              width="60px"
              height="60px"
            />
            <h2>Assignment support</h2>
          </div>
          <div className="service">
            <LazyLoadImage
              alt="service icon"
              effect="blur"
              src={coding}
              placeholderSrc={sqcoding}
              width="60px"
              height="60px"
            />
            <h2>Programming / Coding help</h2>
          </div>
        </div>
      </div>

      <div className="about-us-c">
        <div className="about-us main">
          <div className="main-text">
            <p>Trust is what builds us</p>
            <h1>Why us</h1>
            <p>
              We have 8+ years of experience & industry experts who have vast
              knowledge. We have been transforming lives of many research
              scholars with trust and reliability.Our objective is to bridge the
              gap between the changing needs of research Students with our
              innovative, creative & experienced team. We believe in providing
              quality services and maintaining long-term relationships.
            </p>
          </div>
          <div>
            <LazyLoadImage
              alt="qodeit"
              effect="blur"
              src={first}
              placeholderSrc={rfirst}
              width="80%"
              height="auto"
            />
          </div>
        </div>
      </div>

      <div className="testimonials">
        <div className="service-head-text">
          <p>We have done it</p>
          <h1>Testimonials</h1>
        </div>
        <div className="reviews">
          <div className="form">
            <div className="form-c">
              <form name="hform" method="post">
                <input type="hidden" name="form-name" value="hform" />

                <label>
                  Name
                  <input
                    type="text"
                    placeholder="Your name"
                    name="name"
                  ></input>
                </label>
                <label>
                  Email
                  <input
                    type="email"
                    placeholder="Your email address"
                    name="email"
                  ></input>
                </label>
                <label>
                  Mobile
                  <input
                    type="tel"
                    placeholder="Mobile number"
                    name="number"
                  ></input>
                </label>

                <textarea placeholder="Message" name="message"></textarea>
                <button className="form-btn">Submit</button>
              </form>
            </div>
          </div>
          <div className="review-slider">
            <div className="review-head-text">
              <p>Our work speaks louder</p>
              <h1>Lovely people say about us</h1>
            </div>
            <div className="review">
              <div className="customer">
                <LazyLoadImage
                  alt="picture"
                  effect="blur"
                  src={defaultUser}
                  placeholderSrc={sqdefaultUser}
                  width="80px"
                  height="80px"
                />
                <div>
                  <h2>{reviews[ir].name}</h2>
                  <p>{reviews[ir].pos}</p>
                </div>
              </div>
              <p>{reviews[ir].review}</p>
            </div>
            <button
              onClick={() => {
                cir((prev) => (prev + 1) % reviews.length);
              }}
            >
              <LazyLoadImage
                alt="right arrow"
                effect="blur"
                src={rarrow}
                placeholderSrc={sqrarrow}
                width="100%"
                height="6px"
              />
            </button>
          </div>
        </div>
      </div>
      <RFooter />
    </div>
  );
}

export default RHomepage;
